/** Normalize API restrictionType to UI/API string form. */
export const normalizeRestrictionType = (value) => {
  if (value === 1 || value === "1" || value === "Frozen") return "Frozen";
  return "Restricted";
};

export const RESTRICTION_TYPE_OPTIONS = [
  {
    value: "Restricted",
    label: "Restricted",
    helper:
      "Blocks trading when this rule is violated during rebalancing.",
  },
  {
    value: "Frozen",
    label: "Frozen",
    helper:
      "Hard freeze — the ticker cannot be traded and takes priority over restricted rules.",
  },
];

export const getRestrictionTypeHelper = (value) =>
  RESTRICTION_TYPE_OPTIONS.find((o) => o.value === normalizeRestrictionType(value))
    ?.helper || RESTRICTION_TYPE_OPTIONS[0].helper;
